import React, { useEffect, useState } from "react";
import { Prompt } from "react-router";
import { Form, FormProps, Input, Radio, Typography } from "antd";
import { FormInstance } from "antd/es/form";
import { LEAVE_CONFIRMATION, validateMessages } from "constants/common";
import { span } from "utils/style";
import styles from "./AccessControlForm.module.scss";

export interface EmailDomainFormValues {
  id?: number;
  emailDomain: string;
  blockRegistration: boolean;
  blockLogin: boolean;
}

export interface AccessControlFormProps extends Pick<FormProps<EmailDomainFormValues>, "onFinish"> {
  form: FormInstance<EmailDomainFormValues>;
  data?: Partial<EmailDomainFormValues>;
}

function AccessControlForm({ data, form, onFinish }: AccessControlFormProps) {
  const [submitted, setSubmitted] = useState(false);

  useEffect(() => {
    if (!submitted) form.resetFields();
  }, [form, data, submitted]);

  return (
    <>
      <Prompt when={!submitted} message={LEAVE_CONFIRMATION} />
      <Form
        form={form}
        layout="inline"
        labelAlign="left"
        initialValues={data}
        validateMessages={validateMessages}
        validateTrigger={["onBlur", "onSubmit"]}
        className={styles.form}
        onFinish={(values) => {
          setSubmitted(true);
          onFinish && onFinish(values);
        }}
      >
        <Form.Item label="Domain" name="emailDomain" style={span(8)} rules={[{ required: true }]}>
          <Input />
        </Form.Item>
        <Form.Item style={span(16)} />
        <Form.Item label="Block registration" name="blockRegistration" rules={[{ required: true }]} style={span(6)}>
          <Radio.Group
            options={[
              { value: true, label: "Yes", style: { flexGrow: 1 } },
              { value: false, label: "No", style: { flexGrow: 1 } },
            ]}
          />
        </Form.Item>
        <Form.Item label="Block login" name="blockLogin" rules={[{ required: true }]} style={span(6)}>
          <Radio.Group
            options={[
              { value: true, label: "Yes", style: { flexGrow: 1 } },
              { value: false, label: "No", style: { flexGrow: 1 } },
            ]}
          />
        </Form.Item>
        <Form.Item style={span(24)}>
          <Typography.Text type="warning">Blocking a domain may affect multiple users</Typography.Text>
        </Form.Item>
        <Form.Item name="id" noStyle hidden />
      </Form>
    </>
  );
}

export default AccessControlForm;
